export function lerp(start, end, amt){
    return (1 - amt) * start + amt * end
}


/*
** Round number with n decimals
*/

export const round = (x, n=2) => {
    const decimals = 10 ** n
    return Math.round(x * decimals)/decimals
}
